import { render, staticRenderFns } from "./SelectX.vue?vue&type=template&id=7da22ec8&scoped=true&"
import script from "./SelectX.vue?vue&type=script&lang=js&"
export * from "./SelectX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da22ec8",
  null
  
)

export default component.exports